<template>
  <div class="taskAddItem">
    <Header :title="title" type="0" route="/taskAdd/index"></Header>
    <div class="research">
      <el-table :data="tableData" ref="tableDataRef" border style="width: 100%">
        <el-table-column prop="xm" label="姓名" min-width="20%" align="center">
        </el-table-column>
        <el-table-column prop="xh" label="学号" min-width="35%" align="center">
        </el-table-column>
        <el-table-column prop="xh" label="班级" min-width="35%" align="center">
        </el-table-column>
        <el-table-column :label="'任务' + label" min-width="15%" align="center">
          <template slot-scope="scope">
            <el-button @click="goDetail(scope.row)" type="text" size="small">{{
              label
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      tableData: [],
      title: "",
      label: ""
    };
  },
  created() {
    this.$route.query.list = JSON.parse(this.$route.query.list);
    this.title = this.$route.query.list.title;
    this.label = this.$route.query.list.title == "学生详情" ? "详情" : "评价";
    this.getList();
  },
  methods: {
    async getList() {
      let params = {};
      if (this.title == "学生详情") {
        params = {
          id: this.$route.query.list.id,
          lx: "mx"
        };
      } else {
        params = {
          id: this.$route.query.list.id,
          lx: "pj"
        };
      }
      const res = await Api.getsxrwfbpjxslist(params);
      this.tableData = res.data;
    },
    goDetail(item) {
      item.title = this.$route.query.list.title;

      if (this.title == "学生详情") {
        this.$router.push({
          path: "/taskAdd/studentDetail",
          query: {
            list: item,
            label: "任务详情"
          }
        });
      } else {
        this.$router.push({
          path: "/taskAdd/evaluateItem",
          query: {
            list: item,
            label: "任务评价"
          }
        });
      }
    }
  }
};
</script>
<style lang="less">
.taskAddItem .research {
  padding: 0 20px;
  .label-class {
    display: flex;
    align-items: center;
    i {
      color: #969799;
    }
  }
}
</style>
<style lang="less">
.taskAddItem {
  .el-table td {
    border-bottom: 1px solid #ebeef5 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/taskAdd/item.vue